import { render } from "./CreateCompany.vue?vue&type=template&id=6b90d8b0&scoped=true"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"

import "./CreateCompany.vue?vue&type=style&index=0&id=6b90d8b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b90d8b0"]])

export default __exports__